// For the font, inspect the HTML element you're using and enter something like the following:
// calculateTextWidth("hello there!", "bold 12pt arial")
export function calculateTextWidth(text, font, lineHeight) {
  // re-use canvas object for better performance
  var canvas = calculateTextWidth.canvas || (calculateTextWidth.canvas = document.createElement('canvas'))
  var context = canvas.getContext('2d')
  context.font = font
  context.lineHeight = lineHeight
  var metrics = context.measureText(text)
  return metrics.width
}


export function splitByAllCapitalLetters(value) {
  if (value == null) {
    return ''
  }

  return value.split(/(?=[A-Z])/).join(' ')
}

export function splitByCapitalLetter(value) {
  if (value == null) {
    return ''
  }

  return (value.charAt(0).toUpperCase()) + value.split(/(?=[A-Z])/).join(' ').slice(1)
}

export function splitCapitalizeByChar(value, letter) {
  if (value == null) {
    return ''
  }

  return (value.charAt(0).toUpperCase()) + value.split(letter).join(' ').slice(1)
}

export function capitalize(word) {
  return word.charAt(0).toUpperCase() + word.slice(1)
}

export function getWidthOfText(txt, fontsize = '16px', fontname = 'Roboto') {
  if (getWidthOfText.c === undefined) {
    getWidthOfText.c = document.createElement('canvas')
    getWidthOfText.ctx = getWidthOfText.c.getContext('2d')
  }
  
  var fontspec = fontsize + ' ' + fontname
  if (getWidthOfText.ctx.font !== fontspec)
    getWidthOfText.ctx.font = fontspec
  return getWidthOfText.ctx.measureText(txt).width
}

export const pluralize = (noun, count, ending) => count != 1 ? `${ noun }${ ending ? ending : 's' }` : noun

export function combineStringItem(stringArr, sort = true) {
  if (sort) {
    stringArr = stringArr.sort()
  }
  if (stringArr.length > 1) {
    let lastTwoElements = stringArr.slice(-2)
    let lastTwoElementString = lastTwoElements.join(' and ')
    let preElements = stringArr.slice(0, stringArr.length - 2)
    if (preElements.length != 0) {
      let preElementsString = preElements.join(', ') + ', '
      return preElementsString + lastTwoElementString
    }
    return lastTwoElementString
  } else if (stringArr.length == 1) {
    return stringArr[0]
  } else {
    return ''
  }
}

// https://stackoverflow.com/questions/33855641/copy-output-of-a-javascript-variable-to-the-clipboard
export function copyToClipboard(text) {
  var dummy = document.createElement('textarea')
  // to avoid breaking orgain page when copying more words
  // cant copy when adding below this code
  // dummy.style.display = 'none'
  document.body.appendChild(dummy)
  //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
  dummy.value = text
  dummy.select()
  document.execCommand('copy')
  document.body.removeChild(dummy)
}